import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import SeePitchesBy from 'components/Configs/SeePitchesBy';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import { PlayerHandedness, PitchTagging } from 'types/CodegenReportTypes';
import usePlayerReportBatter from 'hooks/PlayerReport/Batter/usePlayerReportBatter';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type Props = {
  isConfigOpen: boolean;
  setConfigOpen: () => void;
};

const BatterConfig = ({ isConfigOpen, setConfigOpen }: Props) => {
  const { isCreate } = useReportId();

  const { specialConfigOptions, selectedConfgValues, setSelectedConfigValue, isLoadingReport } = usePlayerReportBatter();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader isOpen={isConfigOpen} onClick={setConfigOpen} title={t('Adjust report content')} isEnabled={isCreate} />
      {isConfigOpen && (
        <div className='report-layout-shelf-section'>
          <GenericRadioConfig
            label={t('Pitch tagging:')}
            options={['Auto', 'Manual'] satisfies PitchTagging[]}
            selected={selectedConfgValues.pitchTagging}
            setSelected={(newValue) => setSelectedConfigValue('pitchTagging', newValue)}
            disabled={isLoadingReport}
          />
          <GenericRadioConfig
            label={t('Pitcher handedness:')}
            options={['Both', 'Left', 'Right'] satisfies PlayerHandedness[]}
            selected={selectedConfgValues.playerHandedness}
            setSelected={(newValue) => setSelectedConfigValue('playerHandedness', newValue)}
            disabled={isLoadingReport}
          />
          <SeePitchesBy
            seePitchesBy={selectedConfgValues.pitchGrouping}
            setSeePitchesBy={(newValue) => setSelectedConfigValue('pitchGrouping', newValue)}
            pitchTypes={selectedConfgValues.pitchTypes}
            setPitchTypes={(newValue) => setSelectedConfigValue('pitchTypes', newValue)}
            pitchTypeGroups={selectedConfgValues.pitchTypeGroups}
            setPitchTypeGroups={(newValue) => setSelectedConfigValue('pitchTypeGroups', newValue)}
            disabled={isLoadingReport}
            availablePitchTypes={
              selectedConfgValues.pitchTagging === 'Auto'
                ? specialConfigOptions?.pitchTypeInfo.availableAutoPitchTypes
                : specialConfigOptions?.pitchTypeInfo.availableManualPitchTypes
            }
            availablePitchTypeGroups={
              selectedConfgValues.pitchTagging === 'Auto'
                ? specialConfigOptions?.pitchTypeInfo.availableAutoPitchTypeGroups
                : specialConfigOptions?.pitchTypeInfo.availableManualPitchTypeGroups
            }
          />
        </div>
      )}
    </>
  );
};

export default BatterConfig;
